/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Load_MoreInputs */



/**
* | output |
* | --- |
* | "Load More" |
*
* @param {Explorer_Search_Load_MoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_load_more = /** @type {((inputs?: Explorer_Search_Load_MoreInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Load_MoreInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Load More")
	if (locale === "de") return /** @type {LocalizedString} */ ("Load More")
	if (locale === "it") return /** @type {LocalizedString} */ ("Load More")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Load More")
	if (locale === "es") return /** @type {LocalizedString} */ ("Load More")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Load More")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Load More")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Load More")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Load More")
	return /** @type {LocalizedString} */ ("Load More")
});